import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zhHans from './zh-Hans.json';

/** Detect preferred locale: localStorage → navigator.language → 'en' */
function detectLocale(): 'en' | 'zh-Hans' {
  const stored = localStorage.getItem('stanwars.lang');
  if (stored === 'zh-Hans' || stored === 'en') return stored;
  const nav = navigator.language ?? '';
  if (nav.startsWith('zh')) return 'zh-Hans';
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-Hans': { translation: zhHans },
    },
    lng: detectLocale(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
